// De antwoorden in de enquête-widget (feedbackWidget), los van het scherm zodat ze te proeven zijn. (Martijn 14-10-2026)
//
// Drie soorten vraag, uit Enquetefield.type:
//   sterren    (leeg, "stars" of iets onbekends) -- 0,5 tot 5 sterren, met een open toelichting ernaast;
//   nps        "Zou je ons aanraden?" -- 0 tot en met 10, en 0 is ook een antwoord;
//   open       "textarea" of "text" -- alleen tekst.
//
// Een antwoord hoort bij de vraag via idenquetefield. Tot 14-10-2026 ging dat via de naam zonder spaties: twee vragen met
// dezelfde naam (of een vertaalde naam) liepen door elkaar, en wie eerst de toelichting typte stuurde een antwoord zonder
// vraagnummer. "Volgende" kon pas als ELKE vraag sterren had; nu alleen als elke VERPLICHTE vraag beantwoord is.

/** De soort van een vraag: 'sterren', 'nps' of 'open'. */
export function soortVan(type) {
    const t = String(type ?? '').trim().toLowerCase();
    if (t === 'nps') return 'nps';
    if (t === 'textarea' || t === 'text') return 'open';
    return 'sterren';
}

/** Het antwoord op deze vraag, of undefined. */
export function antwoordOp(antwoorden, idenquetefield) {
    return (antwoorden || []).find((a) => a && a.idenquetefield === idenquetefield);
}

/**
 * Zet (een deel van) het antwoord op een vraag; geeft een nieuwe lijst. `wijziging` is { rating } of { data }.
 * Een vraag zonder nummer telt niet mee (er valt niets op te slaan).
 */
export function zetAntwoord(antwoorden, idenquetefield, wijziging) {
    const lijst = Array.isArray(antwoorden) ? antwoorden : [];
    if (idenquetefield == null) return lijst;

    let gevonden = false;
    const nieuw = lijst.map((a) => {
        if (a && a.idenquetefield === idenquetefield) {
            gevonden = true;
            return { ...a, ...wijziging };
        }
        return a;
    });
    if (!gevonden) nieuw.push({ idenquetefield, ...wijziging });
    return nieuw;
}

/** Is deze vraag beantwoord? Sterren: meer dan 0. NPS: een getal van 0 tot en met 10. Open: niet leeg. */
export function isBeantwoord(vraag, antwoord) {
    if (!antwoord) return false;
    switch (soortVan(vraag?.type)) {
        case 'nps':
            return Number.isInteger(antwoord.rating) && antwoord.rating >= 0 && antwoord.rating <= 10;
        case 'open':
            return typeof antwoord.data === 'string' && antwoord.data.trim().length > 0;
        default:
            return Number(antwoord.rating) > 0;
    }
}

/** Mag de gast door ("Volgende")? Alleen als elke verplichte vraag beantwoord is. */
export function magVerder(vragen, antwoorden) {
    return (vragen || []).every((v) => !v?.required || isBeantwoord(v, antwoordOp(antwoorden, v.idenquetefield)));
}

/**
 * Wat er naar CreateEnquete gaat: per beantwoorde vraag { idenquetefield, rating, data }. Rating is 0 bij open tekst
 * (de kolom is een getal), data leeg als er niets getypt is.
 */
export function naarVersturen(vragen, antwoorden) {
    const nummers = new Set((vragen || []).map((v) => v?.idenquetefield));
    return (antwoorden || [])
        .filter((a) => a && a.idenquetefield != null && nummers.has(a.idenquetefield))
        .map((a) => ({
            idenquetefield: a.idenquetefield,
            rating: Number.isFinite(Number(a.rating)) ? Number(a.rating) : 0,
            data: typeof a.data === 'string' ? a.data : '',
        }));
}
